export default __webpack_public_path__ + "static/media/green-ufo.f4ccccdb.svg";